import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { UserCog, ShieldCheck } from "lucide-react";
import { useRoleStore } from "@/lib/store";
import type { Role } from "@shared/types";
export function RoleSwitcher() {
  const role = useRoleStore((s) => s.role);
  const setRole = useRoleStore((s) => s.setRole);
  return (
    <div className="surface-panel flex flex-col gap-2 rounded-xl p-3">
      <div className="flex items-center justify-between px-1">
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
          <UserCog className="h-3 w-3" />
          Active Role
        </span>
        <Badge
          variant={role === 'Admin' ? 'primary' : 'secondary'}
          className="text-[9px] h-5 px-2"
        >
          {role === 'Admin' && <ShieldCheck className="h-2 w-2 mr-1" />}
          {role}
        </Badge>
      </div>
      <Select value={role} onValueChange={(val) => setRole(val as Role)}>
        <SelectTrigger className="h-9 rounded-lg border-border bg-secondary text-xs font-medium focus:ring-ring">
          <SelectValue placeholder="Select Role" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Admin" className="text-xs font-bold">System Admin</SelectItem>
          <SelectItem value="Manager" className="text-xs">Manager</SelectItem>
          <SelectItem value="Officer" className="text-xs">Field Officer</SelectItem>
          <SelectItem value="Accountant" className="text-xs">Accountant</SelectItem>
          <SelectItem value="Client" className="text-xs">Client Portal</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
